import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "../axios/AxiosInstance";
import {
  Users,
  Plus,
  Search,
  Filter,
  Eye,
  Edit,
  Phone,
  Mail,
  MapPin,
  Building,
  TrendingUp,
  MoreVertical,
  Grid3X3,
  List,
  Star,
  Calendar,
  DollarSign,
  CheckCircle2,
  Clock,
  XCircle,
  AlertCircle
} from "lucide-react";
import { Modal, message } from "antd";
import { useNavigate } from "react-router-dom";
import ClientDetail from "./ClientDetail";
import { toast } from "sonner";
import CreateClientModal from "./clients/CreateClientModal";

// import { ClientModel } from 'types'; // Type import commented out as per user request

export default function ClientsPage() {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [originalClients, setOriginalClients] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState(null);
  const [timer, setTimer] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("grid"); // "grid" ou "list"
  const [currentTab, setCurrentTab] = useState("all");

  //company
  const [siret, setSiret] = useState("");
  const [denomination, setDenomination] = useState("");
  const [ape, setApe] = useState("");
  const [address, setAddress] = useState("");
  const [town, setTown] = useState("");
  const [postCode, setPostCode] = useState("");
  const [tva, setTva] = useState("");
  const [tvaRate, setTvaRate] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");
  const [pld, setPld] = useState("");

  //ADRESSES

  const [addressLivraison, setAddressLivraison] = useState("");
  const [postCodeLivraison, setPostcodeLivraison] = useState("");
  const [townLivraison, setTownLivraison] = useState("");

  const [addressFacturation, setAddressFacturation] = useState("");
  const [postcodeFacturation, setPostcodeFacturation] = useState("");
  const [townFacturation, setTownFacturation] = useState("");

  //contact
  const [contactFirstname, setContactFirstname] = useState("");
  const [contactLastname, setContactLastname] = useState("");
  const [contactEMail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");

  //facturation

  const [facturation, setFacturation] = useState("");

  const cancelButtonRef = useRef(null);

  const [isContact, setIsContact] = useState(false);
  const [isCompany, setIsCompany] = useState(true);
  const [isAddress, setIsAddress] = useState(false);
  const [isFacturation, setIsFacturation] = useState(false);

  const paymentConditions = [
    "À Réception",
    "À 10 jours",
    "À 15 jours",
    "Fin de mois",
    "30 jours date de facture",
    "30 jours fdm",
    "30 jours fdm le 5",
    "30 jours fdm le 10",
    "30 jours fdm le 15",
    "30 jours fdm le 20",
    "30 jours fdm le 25",
    "À 45 jours",
    "À 45 jours fdm",
    "60 jours date de facture",
    "60 jours fdm",
    "60 jours fdm le 5",
    "60 jours fdm le 10",
    "60 jours fdm le 15",
    "60 jours fdm le 20",
    "60 jours fdm le 25",
  ];

  const TVA = [
    "TVA 20%",
    "TVA 10%",
    "TVA 8.5%",
    "TVA 5.5%",
    "TVA 2.1%",
    "TVA 0% UE",
    "TVA 0% HORS UE",
  ];

  const tvaArray = TVA.map((tva) => {
    return {
      value: tva,
      label: tva,
    };
  });

  const paymentConditionArray = paymentConditions.map((paymentCondition) => {
    return {
      value: paymentCondition,
      label: paymentCondition,
    };
  });

  const searchSiret = (siret) => {
    setSiret(siret);
    if (siret.length === 14) {
      axios
        .get(`https://data.siren-api.fr/v3/etablissements/${siret}`, {
          headers: {
            //"X-Client-Secret":"IK4mmW87u8wiOqb79n6yRqcX93dTQF2x"
          },
        })
        .then((res) => {
          console.log(res);
          setSiret(siret);
          setDenomination(res.data.etablissement.unite_legale.denomination);
          setApe(res.data.etablissement.unite_legale.activite_principale);
          setAddress(
            res.data.etablissement.numero_voie +
              " " +
              res.data.etablissement.type_voie +
              " " +
              res.data.etablissement.libelle_voie,
          );
          setTown(res.data.etablissement.libelle_commune);
          setPostCode(res.data.etablissement.code_postal);
        })
        .catch((e) => console.log(e));

      return;
    }
  };

  const setSection = (section) => {
    if (section === "address") {
      if (
        !siret.length ||
        !denomination.length ||
        !ape.length ||
        !tva.length ||
        !address.length ||
        !postCode.length ||
        !town.length
      ) {
        message.error("remplissez tous les champs");
        return;
      }

      setIsAddress(true);
      setIsCompany(false);
      setIsContact(false);
      setIsFacturation(false);
    }

    if (section === "company") {
      setIsAddress(false);
      setIsCompany(true);
      setIsContact(false);
      setIsFacturation(false);
    }

    if (section === "contact") {
      if (
        !postCodeLivraison.length ||
        !postcodeFacturation.length ||
        !townLivraison.length ||
        !townFacturation.length ||
        !addressLivraison.length ||
        !addressFacturation.length
      ) {
        message.error("remplissez tous les champs");
        return;
      }

      setIsAddress(false);
      setIsCompany(false);
      setIsContact(true);
      setIsFacturation(false);
    }

    if (section === "facturation") {
      if (
        !contactEMail.length ||
        !contactFirstname.length ||
        !contactLastname.length ||
        !contactPhone.length
      ) {
        message.error("remplissez tous les champs");
        return;
      }

      setIsAddress(false);
      setIsCompany(false);
      setIsContact(false);
      setIsFacturation(true);
    }
  };

  const resetFields = () => {
    setIsAddress(false);
    setIsCompany(true);
    setIsContact(false);
    setIsFacturation(false);
    setIsOpenModal(false);
  };

  const selectFacturation = (e) => {
    setFacturation(e);
  };

  const addClient = () => {
    if (!facturation.length) {
      message.error("remplissez tous les champs");
      return;
    }

    axios
      .post("client", {
        siret,
        companyName: denomination,
        address: address,
        town: town,
        postCode: postCode,
        pld: pld,
        APE: ape,
        TVA: tva,
        addressLivraison,
        addressFacturation,
        postCodeLivraison,
        postCodeFacturation: postcodeFacturation,
        townLivraison,
        townFacturation,
        contacts: [
          {
            firstname: contactFirstname,
            lastname: contactLastname,
            email: contactEMail,
            mobile: contactPhone.split(" ").join(""),
          },
        ],
        contactFirstname,
        contactLastname,
        contactEMail,
        contactPhone,
        facturation,
        tvaRate,
      })
      .then((res) => {
        message.success("Client créé");
        console.log(res);
        const newClients = [...clients];
        newClients.push(res.data);
        setSection("company");
        setClients(newClients);
        setIsOpenModal(false);
      })
      .catch((e) => {
        if (e.response.data.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
        } else if (e.response.data.statusCode === 409) {
          message.error("Le client existe deja!");
        }
      });
  };

  const copySiegeAddressLivraison = () => {
    setAddressLivraison(address);
    setTownLivraison(town);
    setPostcodeLivraison(postCode);
  };

  const copySiegeAddressFacturation = () => {
    setAddressFacturation(address);
    setTownFacturation(town);
    setPostcodeFacturation(postCode);
  };

  const copyLivraisonFacturation = () => {
    setAddressFacturation(addressLivraison);
    setTownFacturation(townLivraison);
    setPostcodeFacturation(postCodeLivraison);
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [newClient, setNewClient] = useState({
    nomComplet: "",
    societe: "",
    email: "",
    telephone: "",
  });
  const [formError, setFormError] = useState("");
  const openModal = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  useEffect(() => {
    loadClients();
  }, []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setNewClient((prev) => ({ ...prev, [id]: value }));
  };
  const loadClients = () => {
    setIsLoading(true);
    axios
      .get("client/freelance")
      .then((res) => {
        setClients(res.data);
        setOriginalClients(res.data);
        console.log(res.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  // Filtrage des clients
  const filteredClients = clients.filter((client) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      client.companyName?.toLowerCase().includes(term) ||
      client.contactEMail?.toLowerCase().includes(term) ||
      client.contactPhone?.includes(term) ||
      client.town?.toLowerCase().includes(term)
    );
  });

  // Calcul des statistiques
  const stats = {
    total: clients.length,
    actifs: clients.filter(c => c.status === "actif" || !c.status).length,
    prospects: clients.filter(c => c.status === "prospect").length,
    inactifs: clients.filter(c => c.status === "inactif").length
  };

  const handleSubmitNewClient = async (e) => {
    e.preventDefault();
    setFormError(""); // Clear previous form errors

    if (!newClient.nomComplet || !newClient.email) {
      const msg = "Le nom complet et l'email sont requis."; // Corrected string
      setFormError(msg);
      toast.error(msg);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(newClient.email)) {
      const msg = "Veuillez saisir une adresse email valide.";
      setFormError(msg);
      toast.error(msg);
      return;
    }

    try {
      const payload = {
        nomComplet: newClient.nomComplet,
        societe: newClient.societe || null, // API expects null for optional empty strings
        email: newClient.email,
        telephone: newClient.telephone || null, // API expects null for optional empty strings
      };

      const response = await fetch("http://localhost:8000/clients", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorMsg = `Erreur HTTP ${response.status}`;
        try {
          const errData = await response.json();
          errorMsg =
            errData.detail ||
            errData.message ||
            "Erreur lors de la création du client.";
        } catch (parseErr) {
          // If parsing fails, use the generic HTTP error
        }
        throw new Error(errorMsg);
      }

      const createdClient = await response.json();

      setClients((prevClients) => [...prevClients, createdClient]);
      setIsDialogOpen(false);
      setNewClient({ nomComplet: "", societe: "", email: "", telephone: "" }); // Reset form
      toast.success(
        `Client "${createdClient.nomComplet}" ajouté avec succès !`,
      );
    } catch (err) {
      console.error("Failed to create client:", err);
      const createErrorMsg =
        err.message ||
        "Échec de la création du client. Vérifiez les informations ou l'email pourrait déjà exister."; // Corrected string
      setFormError(createErrorMsg);
      toast.error(createErrorMsg);
    }
  };

  const pageTitleStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "24px",
    color: "#222",
  };

  const containerStyle = {
    padding: "24px",
    fontFamily: "sans-serif",
    backgroundColor: "white",
    minHeight: "calc(100vh - 64px)", // Assuming a topbar of 64px
  };

  const searchClient = (word) => {
    setSearchTerm(word);
    if (word.length === 0) {
      setClients(originalClients);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        axios
          .post("client/freelance/find-by-text", { query: word })
          .then((res) => {
            setClients(res.data);
          })
          .catch((e) => console.log(e));
      }, 700);
      setTimer(timer2);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="container mx-auto px-6 py-8">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-8 mb-8"
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-4 md:mb-0">
              <div className="flex items-center space-x-3 mb-2">
                <div className="p-3 bg-blue-100 rounded-xl">
                  <Users className="w-8 h-8 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-3xl font-bold text-slate-900">Gestion des Clients</h1>
                  <p className="text-slate-600 text-lg">
                    Gérez votre portefeuille client et prospects
                  </p>
                </div>
              </div>
            </div>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setIsOpenModal(true)}
              className="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:bg-blue-700 transition-all duration-200 flex items-center space-x-2"
            >
              <Plus className="w-5 h-5" />
              <span>Nouveau client</span>
            </motion.button>
          </div>
        </motion.div>

        {/* Statistics Cards */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
        >
          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Total clients</p>
                <p className="text-3xl font-bold text-slate-900 mt-1">{stats.total}</p>
              </div>
              <div className="bg-blue-100 p-3 rounded-lg">
                <Users className="w-6 h-6 text-blue-600" />
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Clients actifs</p>
                <p className="text-3xl font-bold text-green-600 mt-1">{stats.actifs}</p>
              </div>
              <div className="bg-green-100 p-3 rounded-lg">
                <CheckCircle2 className="w-6 h-6 text-green-600" />
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Prospects</p>
                <p className="text-3xl font-bold text-orange-500 mt-1">{stats.prospects}</p>
              </div>
              <div className="bg-orange-100 p-3 rounded-lg">
                <Clock className="w-6 h-6 text-orange-500" />
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Inactifs</p>
                <p className="text-3xl font-bold text-red-500 mt-1">{stats.inactifs}</p>
              </div>
              <div className="bg-red-100 p-3 rounded-lg">
                <XCircle className="w-6 h-6 text-red-500" />
              </div>
            </div>
          </motion.div>
        </motion.div>
        {/* Search and Filters */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
        >
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            {/* Search */}
            <div className="flex-1 max-w-md">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => searchClient(e.target.value)}
                  placeholder="Rechercher un client..."
                  className="pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 w-full"
                />
              </div>
            </div>

            {/* View Mode Toggle */}
            <div className="flex items-center space-x-2 bg-slate-100 rounded-lg p-1">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => setViewMode("grid")}
                className={`p-2 rounded-lg transition-all duration-200 ${
                  viewMode === "grid"
                    ? "bg-white text-slate-900 shadow-sm"
                    : "text-slate-600 hover:text-slate-900"
                }`}
              >
                <Grid3X3 className="w-4 h-4" />
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => setViewMode("list")}
                className={`p-2 rounded-lg transition-all duration-200 ${
                  viewMode === "list"
                    ? "bg-white text-slate-900 shadow-sm"
                    : "text-slate-600 hover:text-slate-900"
                }`}
              >
                <List className="w-4 h-4" />
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* Clients Grid/List */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {isLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : filteredClients.length === 0 ? (
            <div className="text-center py-12">
              <Users className="w-16 h-16 text-slate-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun client trouvé</h3>
              <p className="text-slate-500">
                {searchTerm ? "Essayez de modifier vos critères de recherche" : "Commencez par créer votre premier client"}
              </p>
            </div>
          ) : viewMode === "grid" ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              <AnimatePresence>
                {filteredClients.map((client, index) => (
                  <motion.div
                    key={client._id || index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    whileHover={{ y: -4, scale: 1.02 }}
                    onClick={() => setSelectedClient(client)}
                    className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 cursor-pointer hover:shadow-lg transition-all duration-200"
                  >
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <h3 className="font-bold text-lg text-slate-900 mb-1 line-clamp-2">
                          {client.companyName}
                        </h3>
                        <div className="flex items-center text-sm text-slate-500">
                          <Building className="w-4 h-4 mr-1" />
                          <span>Entreprise</span>
                        </div>
                      </div>
                      <div className="bg-blue-100 p-2 rounded-lg">
                        <Users className="w-4 h-4 text-blue-600" />
                      </div>
                    </div>

                    <div className="space-y-3">
                      <div className="flex items-center text-sm text-slate-600">
                        <MapPin className="w-4 h-4 mr-2 text-slate-400" />
                        <span className="line-clamp-1">
                          {client.address}, {client.postCode} {client.town}
                        </span>
                      </div>

                      {client.contactPhone && (
                        <div className="flex items-center text-sm text-slate-600">
                          <Phone className="w-4 h-4 mr-2 text-slate-400" />
                          <span>{client.contactPhone}</span>
                        </div>
                      )}

                      {client.contactEMail && (
                        <div className="flex items-center text-sm text-slate-600">
                          <Mail className="w-4 h-4 mr-2 text-slate-400" />
                          <span className="line-clamp-1">{client.contactEMail}</span>
                        </div>
                      )}
                    </div>

                    <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        client.status === "actif" || !client.status
                          ? "bg-green-100 text-green-800"
                          : client.status === "prospect"
                          ? "bg-orange-100 text-orange-800"
                          : "bg-red-100 text-red-800"
                      }`}>
                        {client.status === "actif" || !client.status ? "Actif" :
                         client.status === "prospect" ? "Prospect" : "Inactif"}
                      </span>
                      <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        className="p-1 text-slate-400 hover:text-blue-600 transition-colors duration-200"
                      >
                        <Eye className="w-4 h-4" />
                      </motion.button>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
          ) : (
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Client
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Contact
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Localisation
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Statut
                      </th>
                      <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-slate-200">
                    <AnimatePresence>
                      {filteredClients.map((client, index) => (
                        <motion.tr
                          key={client._id || index}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -20 }}
                          transition={{ duration: 0.3, delay: index * 0.05 }}
                          className="hover:bg-slate-50 transition-colors duration-200 cursor-pointer"
                          onClick={() => setSelectedClient(client)}
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <div className="bg-slate-100 p-2 rounded-lg mr-3">
                                <Building className="w-4 h-4 text-slate-600" />
                              </div>
                              <div>
                                <div className="text-sm font-medium text-slate-900">
                                  {client.companyName}
                                </div>
                                <div className="text-sm text-slate-500">
                                  {client.siret || "SIRET non renseigné"}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-slate-900">
                              {client.contactFirstname} {client.contactLastname}
                            </div>
                            <div className="text-sm text-slate-500">
                              {client.contactEMail}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-slate-900">
                              {client.town}
                            </div>
                            <div className="text-sm text-slate-500">
                              {client.postCode}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                              client.status === "actif" || !client.status
                                ? "bg-green-100 text-green-800"
                                : client.status === "prospect"
                                ? "bg-orange-100 text-orange-800"
                                : "bg-red-100 text-red-800"
                            }`}>
                              {client.status === "actif" || !client.status ? "Actif" :
                               client.status === "prospect" ? "Prospect" : "Inactif"}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <div className="flex items-center justify-center space-x-2">
                              <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                                title="Voir le client"
                              >
                                <Eye className="w-4 h-4" />
                              </motion.button>
                              <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                className="p-2 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-all duration-200"
                                title="Modifier"
                              >
                                <Edit className="w-4 h-4" />
                              </motion.button>
                              <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all duration-200"
                                title="Plus d'actions"
                              >
                                <MoreVertical className="w-4 h-4" />
                              </motion.button>
                            </div>
                          </td>
                        </motion.tr>
                      ))}
                    </AnimatePresence>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </motion.div>

        {/* Client Detail Modal */}
        {selectedClient && (
          <ClientDetail
            client={selectedClient}
            originalClients={originalClients}
            setClient={setSelectedClient}
            clients={clients}
            setClients={setClients}
          />
        )}

        {/* Create Client Modal */}
        {isOpenModal && (
          <CreateClientModal
            clients={clients}
            setClients={setClients}
            open={isOpenModal}
            onOpenChange={() => setIsOpenModal(false)}
          />
        )}
      </div>
    </div>
  );
}
